"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluate = void 0;
var ExpressionVisitor_1 = require("./ExpressionVisitor");
var Settings_1 = require("./Settings");
var Tokenizer_1 = require("./Tokenizer");
function evaluate(exp, settings) {
    var scopes = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        scopes[_i - 2] = arguments[_i];
    }
    if (!(settings instanceof Settings_1.Settings)) {
        scopes = __spreadArrays([settings], scopes);
        settings = void 0;
    }
    return new ExpressionVisitor_1.ExpressionVisitor(settings)
        .process(typeof exp === "string"
        ? Tokenizer_1.tokenize(exp, settings)
        : exp, scopes);
}
exports.evaluate = evaluate;
//# sourceMappingURL=evaluator.js.map